// extracted by mini-css-extract-plugin
module.exports = {"prBreadcrumbArea":"Breadcrumb_prBreadcrumbArea__3otnM","breadcrumbTitle":"Breadcrumb_breadcrumbTitle__3fnqh","breadcrumb--2":"Breadcrumb_breadcrumb--2__yVWis"};